import React, { useEffect, useState } from "react";

import { useApp } from "../../Context";
import { useNavigate } from "react-router-dom";


//import components
import {
  AdvertiseModal,
  Feedback,
  Footer,
  FilterModal,
  HomeCard,
  Navbar,
  Button,
  Loader,
  SuchauftragSection,
} from "../../Components";

//assets
import HeroImage from "../../Assets/background-img2.png";
import BackgroundImage from "../../Assets/background-footer.jpg";
import { useGetCitiesQuery } from "../../Services/AdvertiseService";

export default function HomePage() {
  const navigate = useNavigate();

  const { showAdModal, handleShowAdModal } = useApp();

  //services

  const { data: cities, isLoading: loadingCities } = useGetCitiesQuery();

  const [showFilter, setShowFilter] = useState(false);
  const [next, setNext] = useState(6);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleShowFilter = () => setShowFilter((prevState) => !prevState);

  const showMoreCities = () => {
    setNext((prevState) => prevState + 6);
  };

  return (
    <>
      <Navbar />
      {loadingCities && (
        <Loader isLoading={loadingCities} text="Please wait..." />
      )}
      {/* Hero-Bereich mit Suchauftrag-Flow */}
      <div className="mt-14 relative min-h-[700px] md:min-h-[600px]">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/40 to-transparent z-10" />
        <img
          className="absolute inset-0 object-cover w-full h-full object-center"
          src={HeroImage}
          alt="hero-img"
        />
        <div className="relative flex flex-col md:flex-row items-center justify-center gap-10 md:gap-16 md:px-16 px-5 py-16 md:py-20 z-20 max-w-7xl mx-auto min-h-[600px]">
          {/* Linke Seite: Text */}
          <div className="flex flex-col gap-6 md:gap-8 md:w-1/2 text-center md:text-left">
            <h1 className="font-georgia md:text-[45px] text-2xl text-white leading-snug">
              Immobilien finden, <br /> kaufen & verkaufen
            </h1>
            <p className="text-white font-helvetica md:text-[18px] text-md">
              Durchsuchen Sie Angebote, inserieren Sie kostenlos oder beauftragen Sie uns mit der Suche.
            </p>
            <div className="flex flex-col items-center md:items-start gap-3 mt-4">
              <p className="text-white font-helvetica md:text-[18px] text-md font-light">
                Immobilie vermieten oder verkaufen?
              </p>
              <Button
                title="Jetzt kostenlos inserieren"
                variant="secondary"
                full={false}
                onClick={handleShowAdModal}
              />
            </div>
          </div>

          {/* Rechte Seite: Suchauftrag-Flow (kompakt) */}
          <div className="md:w-[480px] w-full flex-shrink-0">
            <SuchauftragSection compact />
          </div>
        </div>
      </div>
      <div className="mt-[87px] text-center flex flex-col gap-2">
        <p className="md:text-[35px] text-2xl font-georgia text-primary">
          Unsere Immobilienanzeigen
        </p>
        <p className="text-primary font-helvetica text-lg">
          Ausgewählte Inserate
        </p>
      </div>
      <div className="flex flex-col items-center justify-center mt-[51px]">
        <p>Städte</p>
        <div className="bg-primary h-1 w-24" />
      </div>
      {/* advertisement section */}
      <div className="mt-[51px] flex justify-center px-5">
        <div className="grid grid-rows-1 md:grid-cols-3 gap-5">
          {cities?.slice(0, next).map((item, idx) => (
            <HomeCard
              key={idx}
              data={item}
              onClick={() => navigate(`/detail/${item.city}`)}
            />
          ))}
        </div>
      </div>
      {cities?.length === 6 && (
        <div className="flex justify-center mt-[41px]">
          <Button
            title="Alle Inserate erkunden"
            variant="primary"
            full={false}
            onClick={showMoreCities}
          />
        </div>
      )}
      <p className="md:text-[35px] text-2xl font-georgia text-primary text-center mt-[61px]">
        Das sagen unsere Kunden
      </p>
      {/* client feedback section */}
      <div className="mt-[20px]">
        <Feedback />
      </div>

      <div
        className="mt-[50px] relative h-[500px] flex items-center"
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-primary/80 to-transparent z-10" />
        <div className="absolute top-[30%] left-20 md:w-1/4 w-3/4 z-20">
          <p className="md:text-[35px] text-2xl font-georgia text-white ">
            Privat inserieren
          </p>
          <p className="text-[18px] font-helvetica text-white font-light mt-[45px] mb-[20px]">
            Sie möchten Ihre Immobilie Privat vermitteln? Wir vernetzen Sie mit
            bereits registrierten Immobilieninteressenten.
          </p>
          <Button
            title="Erstellen"
            variant="secondary"
            full={false}
            onClick={handleShowAdModal}
          />
        </div>
      </div>
      <Footer />
      <FilterModal open={showFilter} handler={handleShowFilter} />
      <AdvertiseModal open={showAdModal} handler={handleShowAdModal} />
    </>
  );
}
